import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { Container } from "reactstrap";

//Common
import { TextField, Chip } from "../../common/VFX-UI";

import ActionBar from "../../common/ActionBar/ActionBar";
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import AutoComplete from "../../../components/common/VFX-UI/Autocomplete/Autocomplete";

//App
import { CountyContext } from "./CountyContainer";
import { CountyContextData, CountyFormProps } from "../../../types/county";
import { EMPTY_GUID } from "../../../utility/constants/constants";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  stateId: Yup.array()
    .min(1, "State is required")
    .required("State is required"),
  sortValue: Yup.number().min(0, "Must be positive number"),
});

const CountyForm = (props: CountyFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);

  const countyContext = useContext<CountyContextData | null>(CountyContext);

  const { id, stateId } = initialVal;
  const title = id === EMPTY_GUID ? "New County" : "Edit County";

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Container>
            <Form noValidate>
              <div className="d-flex justify-content-end mb-3 me-3">
                <Chip label={values.isActive ? "Active" : "Inactive"} />
              </div>
              <TextField
                label="Name"
                type="text"
                name="name"
                isRequired={true}
              />
              <TextField
                label="Description"
                type="textarea"
                name="description"
                isRequired={true}
              />
              <AutoComplete
                disabled={true}
                name="stateId"
                label="State"
                isRequired={true}
                options={countyContext?.states ?? []}
                defaultSelected={
                  stateId != null && stateId.length > 0 ? [stateId[0]] : []
                }
              />
              <TextField label="Display Order" type="number" name="sortValue" />
              <ActionBar
                submitHandler={saveInput}
                cancelHandler={onClose}
                submitText="Submit"
                cancelText="Cancel"
                isLoading={status === "pending"}
              ></ActionBar>
            </Form>
          </Container>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default CountyForm;
